var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"keep"}},[_c('v-main',[_c('asf-loading-spinner-wrapper',{staticStyle:{"height":"100vh"},attrs:{"show-spinner":_vm.showSpinner}},[_c('router-view',{key:_vm.$route.fullPath}),_c('asf-mutation-snackbar'),_c('asf-debug-bar')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }